// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }


// 获取申请状态查询
export function queryCode(data) {
  return request({
    url: "/api/sale_auth/query_code",
    method: "post",
    data,
  });
}






